<h3>
  <span *ngIf="currentMailSender || currentMailRecipient">{{
    'agent:contact.workspace.mail.history.display_mail_information' | translate
  }}</span>
</h3>
<div *ngIf="currentMailSender || currentMailRecipient" id="mailInfoPanelBody">
  <div *ngIf="!isEmpty(currentMailSender)" class="flex-column">
    <div class="label">{{ 'commons:history.mail.from' | translate }}</div>
    <div class="description" [innerHTML]="extractMail(currentMailSender)"></div>
  </div>
  <div *ngIf="!isEmpty(currentMailRecipient)" class="flex-column">
    <div class="label">{{ 'commons:history.mail.to' | translate }}</div>
    <div class="description" [innerHTML]="extractMail(currentMailRecipient)"></div>
  </div>
  <div *ngIf="!isEmpty(currentMailccRecipient)" class="flex-column">
    <div class="label">{{ 'commons:history.mail.cc' | translate }}</div>
    <div class="description" [innerHTML]="extractMail(currentMailccRecipient)"></div>
  </div>
  <div *ngIf="!isEmpty(currentMailBccRecipient)" class="flex-column">
    <div class="label">{{ 'commons:history.mail.bcc' | translate }}</div>
    <div class="description" [innerHTML]="extractMail(currentMailBccRecipient)"></div>
  </div>
  <div *ngIf="!isEmpty(currentMailSubject)" class="flex-column">
    <div class="label">{{ 'commons:basic.timeline.object' | translate }}</div>
    <div class="description" [innerHTML]="currentMailSubject"></div>
  </div>
  <div *ngIf="!isEmpty(currentMailResquetId)" class="flex-column">
    <div class="label">{{ 'commons:history.mail.request_id' | translate }}</div>
    <div class="description" [innerHTML]="currentMailResquetId"></div>
  </div>
</div>
